export const vetKeys = {
  all: ['vet'],
  dashboard: () => [...vetKeys.all, 'dashboard'] as const
} as const;
